<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M32 8.15267H8C6.61929 8.15267 5.5 9.24633 5.5 10.5954V32.0916C5.5 33.4407 6.61929 34.5344 8 34.5344H32C33.3807 34.5344 34.5 33.4407 34.5 32.0916V10.5954C34.5 9.24633 33.3807 8.15267 32 8.15267ZM8 6.68702C5.79086 6.68702 4 8.43687 4 10.5954V32.0916C4 34.2502 5.79086 36 8 36H32C34.2091 36 36 34.2502 36 32.0916V10.5954C36 8.43687 34.2091 6.68702 32 6.68702H8Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M28 4C28.4142 4 28.75 4.3281 28.75 4.73282V9.61832C28.75 10.023 28.4142 10.3511 28 10.3511C27.5858 10.3511 27.25 10.023 27.25 9.61832V4.73282C27.25 4.3281 27.5858 4 28 4Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12 4C12.4142 4 12.75 4.3281 12.75 4.73282V9.61832C12.75 10.023 12.4142 10.3511 12 10.3511C11.5858 10.3511 11.25 10.023 11.25 9.61832V4.73282C11.25 4.3281 11.5858 4 12 4Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.25 15.4809C4.25 15.0762 4.58579 14.7481 5 14.7481L35 14.7481C35.4142 14.7481 35.75 15.0762 35.75 15.4809C35.75 15.8856 35.4142 16.2137 35 16.2137L5 16.2137C4.58579 16.2137 4.25 15.8856 4.25 15.4809Z"
      class="fill-current"
    />
    <path
      d="M13 21C13 22.1046 12.1046 23 11 23C9.89543 23 9 22.1046 9 21C9 19.8954 9.89543 19 11 19C12.1046 19 13 19.8954 13 21Z"
      class="fill-current"
    />
  </svg>
</template>
